// src/components/layout/Footer.js
import { Link } from 'react-router-dom';
import { useLang } from '../../i18n/LanguageContext';
import { useSiteConfig } from '../../context/SiteConfigContext';
import styles from './Footer.module.css';

export default function Footer() {
  const { t, ui } = useLang();
  const { config } = useSiteConfig();

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <span className={styles.logoIcon}>🕯️</span>
          <span className={styles.brandName}>{t(config, 'brand_name')}</span>
          <p className={styles.tagline}>{t(config, 'footer_text')}</p>
        </div>

        <div className={styles.links}>
          <Link to="/">{ui('خانه', 'Home')}</Link>
          <Link to="/portfolio">{ui('نمونه‌کارها', 'Portfolio')}</Link>
          <Link to="/testimonials">{ui('رضایت‌مندی', 'Testimonials')}</Link>
          <Link to="/blog">{ui('مقالات', 'Blog')}</Link>
        </div>

        <div className={styles.contact}>
          <a href={`https://t.me/${config.telegram_id?.replace('@','')}`} target="_blank" rel="noreferrer" className={styles.contactLink}>
            📨 {config.telegram_id}
          </a>
          <a href={`https://eitaa.com/${config.eitaa_id?.replace('@','')}`} target="_blank" rel="noreferrer" className={styles.contactLink}>
            📱 {config.eitaa_id}
          </a>
        </div>
      </div>

      <div className={styles.developer}>
        <span>{t(config, 'developer_label')}: </span>
        <a
          href={config.developer_url || 'https://www.abdifarhad.ir/'}
          target="_blank"
          rel="noreferrer"
          className={styles.developerLink}
        >
          {config.developer_name || 'فرهاد عبدی'}
        </a>
      </div>

      <div className={styles.copy}>
        © {config.copyright_year} {t(config, 'brand_name')} — {t(config, 'footer_text')}
      </div>
    </footer>
  );
}
